import React from "react";
import MuiPopover from "@mui/material/Popover";

export default function PTMPopover(props) {
    const {
        children,
        style,
        content,
        className,
        disableEnforceFocus,
        disableAutoFocus,
        paperProps,
        disabled,
    } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div
                style={style}
                className={className}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                {children}
            </div>
            {!disabled && (
                <MuiPopover
                    id="mouse-over-popover"
                    sx={{
                        pointerEvents: "none",
                    }}
                    open={anchorEl && content}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                    disableAutoFocus={disableAutoFocus}
                    disableEnforceFocus={disableEnforceFocus}
                    slotProps={{
                        paper: paperProps,
                    }}
                >
                    {content}
                </MuiPopover>
            )}
        </>
    );
}
